export const padLeft = (value: number): string => {
  return `${value < 10 ? "0" : ""}${value}`;
};

export const formatDate = (date: Date): string => {
  return `${padLeft(date.getMonth() + 1)}/${padLeft(
    date.getDate()
  )}/${date.getFullYear()}`;
};

export const formatDateFromISOString = (value: string): string => {
  return formatDate(new Date(value));
};

export const formatDateFromYYYYMMDDString = (value: string): string => {
  return formatDate(
    new Date(+value.slice(0, 4), +value.slice(4, 6), +value.slice(6, 8))
  );
};
